export default {"src":"/_next/static/media/scan-and-sign-in.d54eb4d6.svg","height":644,"width":664,"blurWidth":0,"blurHeight":0};